import { createContext } from 'react';
import { IRepairStatusWidget } from './repair-status.props';

export const RepairStatusWidgetContext = createContext<IRepairStatusWidget>({
  data: {},
  isExtended: false,
  setIsExtended: () => console.error('setIsExtended is on defined in RepairStatusWidgetContext.')
});
